<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.parts.trucks.trailer.configuration.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">

                            <div v-if="isAdminMaster() && data._id" class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.parts.perfil.truck.label.decription')}}
                                </p>
                                <form>

                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.company.label.socialName')}}
                                            </label>
                                            <input disabled type="text" v-model="data.socialName" class="form-control" style="background-color:azure">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.orders.company.phone.title')}}
                                            </label>
                                            <input disabled type="text" v-model="data.primaryPhone" class="form-control" style="background-color:azure">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.orders.company.email.title')}}
                                            </label>
                                            <input disabled type="text" v-model="data.email" class="form-control" style="background-color:azure">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.company.label.document')}}
                                            </label>
                                            <input disabled type="text" v-mask="['###.###.###-##', '##.###.###/####-##']" :value="data.document"  class="form-control" style="background-color:azure">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label >
                                                {{$t('string.msg.parts.perfil.truck.manufacturs.label.label')}}
                                            </label>
                                            <select id="manufacturer" v-model="manufacturer"  class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.select.selector.item')}}</option>
                                                <option :value="item._id" v-bind:key="item" v-for="item in manufacturers" >{{camelize(item.name).split('ZZZ_').join('')}}</option>
                                                <option value="*" selected>{{$t('string.msg.select.all')}}</option>
                                            </select>
                                        </div>
                                    </div>


                                    <div id="accordion">
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                    {{$t('string.msg.parts.perfil.truck.families.label.label')}}
                                                    </span>
                                                </h5>
                                            </div>
                                            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                                                <div class="card-body">
                                                    <div class="d-flex flex-wrap">
                                                        <div class="container-switch" :value="item._id" v-bind:key="item._id" v-for="item in families">
                                                            <label class="switch">
                                                                <input 
                                                                    v-model="data.families" 
                                                                    type="checkbox"
                                                                    :id="item._id" 
                                                                    :value="item._id"
                                                                    :name="item.name.split('ZZZ_').join('')"
                                                                    :true-value="item._id"
                                                                    :false-value="null"
                                                                    >
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <span class="label-swith">{{camelize(item.name).split('ZZZ_').join('')}}</span>
                                                        </div>

                                                        <div class="container-switch">
                                                            <label class="switch">
                                                                <input 
                                                                    v-model="data.families" 
                                                                    @click="selectAll()"
                                                                    type="checkbox"
                                                                    id="selectAllItems" 
                                                                    >
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <span class="label-swith">{{$t('string.msg.select.all')}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>
                                    <div class="d-flex justify-content-between bd-highlight mb-3">
          
                                        <button @click="add" class="btn btn-warning w-20 text-dark-gray">{{$t('string.msg.form.btn.add')}}</button>
                                        <button @click="clearForm" class="btn btn-secondary w-20">{{$t('string.msg.form.btn.clear')}}</button>
                                        <button @click="save" class="btn btn-danger w-20">{{$t('string.msg.form.btn.save')}}</button>
                                    </div>
                                    

                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <div  style="height: 100%; overflow: auto;">
                                                    <table class="table table-bordered table-striped" >
                                                        <thead class="thead-dark">
                                                            <tr>
                                                                <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.manufactur')}}</th>
                                                                <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.family')}}</th>
                                                                <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.remove')}}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-bind:key="item" v-for="item in listManufacturer()">
                                                            <tr v-bind:key="item2" v-for="item2 in listFamilies(item)" >
                                                                <td v-if="item.manufacturer">{{camelize(item.manufacturer.name).split('ZZZ_').join('')}}</td>
                                                                <td v-if="item2.name">{{camelize(item2.name).split('ZZZ_').join('')}}</td>
                                                                <td><button @click="remove(item.manufacturer._id, item2._id)" class="btn btn-danger w-20">X</button></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </div>

                            <div v-else-if="!isAdminMaster()" class="card-box">
                                <form>
                                    <div id="accordion">
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                    {{$t('string.msg.parts.perfil.trucktrailer.company.label.title')}}
                                                    </span>
                                                </h5>
                                            </div>
                                            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                                                <br>
                                                <table class="table">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.manufactur')}}</th>
                                                            <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.family')}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-bind:key="item" v-for="item in listManufacturer()">
                                                            <tr v-bind:key="item2" v-for="item2 in listFamilies(item)" >
                                                                <td>{{camelize(item.manufacturer.name).split('ZZZ_').join('')}}</td>
                                                                <td>{{camelize(item2.name).split('ZZZ_').join('')}}</td>
                                                            </tr>
                                                        </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                        <List v-show="isAdminMaster()" v-on:load-item="selectItem"/>
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <FlashMessage/>
    </div>
</template>

<script>
import Controller from './CrtPerfil';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import List from './ListCompanies';

export default {
  name: 'PerfilTruck',
  components: {
    Spinner,
    Toast,
    List
  },
  data() {
      return {
        errors: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        manufacturer: -1,
        manufacturers: [],
        families: [],
        manufacturerFamilies: [],
        user: null,
        data: {
            manufacturers: [],
            families: [],
            manufacturerFamilies: []
        }
      }
  },
  methods: Controller.methods,
  created() {    
  },
  computed: {
      lisElements: function () {
        if (this.data.manufacturerFamilies && this.data.manufacturerFamilies.length>0){
            let items = this.data.manufacturerFamilies.filter(i => i ? i.type : '' === 'TRUCK_TRAILER');
            return items;
        }else{
            return [];
        }
        
    },
  },
  mounted(){
      Controller.init(this);
  }
}
</script>

<style>
</style>
